<template>
  <top-menu-button
    v-for="(button, index) in buttons"
    :key="index"
    :link-to="button.link"
    :icon="button.icon"
    :active="$route.path === button.link"
  />
</template>

<script>
import { helpSharp, settingsSharp} from 'ionicons/icons';
import TopMenuButton from './TopNavigationButton.vue';
export default {
    components: {
        TopMenuButton
    },
    data() {
        return {
            buttons: [
                { description: 'Hilfe', link: '/help', icon: helpSharp },
                { description: 'Einstellungen', link: '/settings', icon: settingsSharp },
            ]
        };
    }
};
</script>
